/* All user-facing text, EN + IT. Components zip list translations
   (work.projects, documents.items) with their static asset arrays by index. */

const strings = {
  en: {
    nav: { hero: "Home", about: "About", skills: "Skills", work: "Projects", documents: "Documents", contact: "Contact" },
    desktop: { skills: "My Computer", work: "My Projects", documents: "My Documents", contact: "Connect" },
    hero: {
      title: "C:\\WELCOME.EXE",
      kicker: "Hi, my name is",
      headline: "I build machine learning that runs on constrained hardware.",
      blurb: "Embedded and on-device AI, parameter-efficient deep learning and computer vision. Based in Salerno, Italy. Explore the",
      blurbProjects: "My Projects",
      blurbEnd: "window below to see my work, or grab my CV for the full overview.",
      viewWork: "View Work",
      viewCV: "View CV",
      marquee: "★ Welcome to my homepage ★   Best viewed at 800×600   ★   Embedded & On-Device AI · Efficient Deep Learning · Computer Vision · IoT   ★   Thanks for stopping by!   ★",
      highlightsTitle: "Recent highlights",
      highlights: [
        "Trained a neural network directly on an STM32 Cortex-M4, with backpropagation written from scratch in C: 22 microsecond inference in roughly 2 KB of RAM.",
        "Master's thesis: LoRA adapters matched full fine-tuning of a 326M-parameter speech model while training around ten times fewer parameters.",
        "Currently prototyping GAN-based face anonymisation for edge hardware, so video can be de-identified before it leaves the camera.",
      ],
      ready: "Ready",
    },
    about: {
      title: "About Me - Notepad",
      menu: ["File", "Edit", "Search", "Help"],
      statusFile: "readme.txt",
      statusPos: "Ln 1, Col 1",
      p1a: "I'm a ", p1b: "machine learning engineer", p1c: " working on embedded and on-device AI: models that have to fit inside tight memory, latency and power budgets and still be worth running.",
      p2a: "My research has centred on running large pretrained models cheaply, through ", p2b: "parameter-efficient fine-tuning and self-supervised learning", p2c: ", on problems from visual speech recognition to epileptic-seizure detection from EEG.",
      p3a: "I recently earned an M.Sc. in the ", p3b: "Internet of Things", p3c: " (108/110) at the ", p3d: "University of Salerno", p3e: ", with a thesis on efficient visual speech recognition.",
    },
    skills: {
      title: "My Computer - Skills",
      menu: ["File", "Edit", "View", "Help"],
      statusObjects: (n) => `${n} object(s)`,
      statusPlace: "My Computer",
    },
    work: {
      title: "My Projects",
      menu: ["File", "Edit", "View", "Go", "Help"],
      statusCount: (n) => `${n} project(s)`,
      statusHint: "Double-click to open",
      projects: [
        { title: "Visual Speech Recognition via PEFT", desc: "Master's thesis (108/110): visual-only lip reading with LoRA adapters on a frozen 326M-parameter AV-HuBERT backbone, matching full fine-tuning while training around ten times fewer parameters.", labels: ["Thesis", "Slides"] },
        { title: "On-Device Intrusion Detection (STM32)", desc: "A neural network trained and run entirely on an STM32 Cortex-M4, with backpropagation written from scratch in C. 22 microsecond inference in roughly 2 KB of RAM.", labels: ["Code", "Slides"] },
        { title: "Smart Emergency Traffic Control", desc: "Deep reinforcement learning for traffic-signal optimization across multi-intersection networks.", labels: ["Code", "Report", "Slides"] },
        { title: "Smart Monitoring for Hospital Wards", desc: "Human-computer interaction project: IoT ward monitoring, prototyped and usability-tested with 12 clinical participants.", labels: ["Slides", "Video"] },
        { title: "Industrial Predictive Maintenance", desc: "Systematic literature review of ML-driven predictive maintenance on industrial sensor data.", labels: ["Report", "Slides"] },
        { title: "Cleaning Robot, built test-first", desc: "Six user stories for an embedded cleaning robot, implemented entirely with test-driven development.", labels: ["Code", "Slides"] },
        { title: "AI-Generated Art Detection", desc: "Deep-learning CNN model that distinguishes AI-generated artwork from human-made art.", labels: ["Demo", "Report", "Slides"] },
        { title: "Fire Detection & Fan Control", desc: "IoT fire-detection system with MQTT monitoring and an automated temperature response.", labels: ["Code", "Demo"] },
        { title: "Self-Supervised Seizure Detection", desc: "Self-supervised pretraining for epileptic-seizure detection from EEG. Master's thesis & publication.", labels: ["Thesis", "Publication"] },
        { title: "Java CRUD Application", desc: "Bachelor's final project: desktop database app with full create/read/update/delete operations.", labels: ["Report"] },
        { title: "Archi-Design Studio Site", desc: "Responsive architecture-studio landing site built with React.", labels: ["Demo", "Code"] },
      ],
    },
    documents: {
      title: "My Documents - Reports & Research",
      menu: ["File", "Edit", "View", "Help"],
      colName: "Name", colType: "Type", colOpen: "Open",
      view: "View →",
      statusCount: (n) => `${n} document(s)`,
      items: [
        { name: "Efficient VSR via PEFT of Frozen Backbones", kind: "Master's Thesis (IoT)" },
        { name: "Self-Supervised Learning for Seizure Detection", kind: "Master's Thesis" },
        { name: "Data-Centric Industrial Predictive Maintenance", kind: "Literature Review" },
        { name: "AI-Generated Art Detection", kind: "Project Report" },
        { name: "Smart Emergency Traffic Control", kind: "Project Report" },
        { name: "IoT Security - Intrusion Detection System", kind: "Presentation" },
        { name: "Software Dependability - Apache Commons CLI", kind: "Project Report" },
        { name: "Cleaning Robot, Test-Driven Development", kind: "Presentation" },
        { name: "Smart Monitoring System for Hospital Wards", kind: "Presentation" },
        { name: "Temperature-Controlled DC Motor", kind: "Project Report" },
        { name: "Java CRUD Application (PFE Licence SI)", kind: "Bachelor's Project" },
      ],
    },
    contact: {
      title: "New Message - Let's Connect",
      intro: "Like what you see? Drop me a line. Click the address to copy it.",
      to: "To:",
      copyTitle: "Copy to clipboard",
      copied: "✓ Copied to clipboard!",
      findMe: "Or find me on:",
      resume: "CV",
      statusOnline: "Online",
      statusRecipient: "1 recipient",
    },
    footer: {
      madeA: "Made with", madeC: "by Zakarya",
      visitor: "You are visitor",
    },
    taskbar: {
      start: "Start",
      shutdown: "Shut Down…",
      safeOff1: "It's now safe to turn off",
      safeOff2: "your computer.",
      powerOn: "⏻ Power back on",
      appearance: "Appearance",
      resume: "CV",
      email: "E-mail",
      langTitle: "Language: English, click for Italiano",
    },
  },

  it: {
    nav: { hero: "Home", about: "Informazioni", skills: "Competenze", work: "Progetti", documents: "Documenti", contact: "Contatti" },
    desktop: { skills: "Risorse del computer", work: "Progetti", documents: "Documenti", contact: "Contatti" },
    hero: {
      title: "C:\\BENVENUTO.EXE",
      kicker: "Ciao, mi chiamo",
      headline: "Costruisco machine learning che gira su hardware con risorse limitate.",
      blurb: "AI embedded e on-device, deep learning parameter-efficient e computer vision. Con base a Salerno, Italia. Esplora la finestra",
      blurbProjects: "Progetti",
      blurbEnd: "qui sotto per vedere i miei lavori, oppure scarica il CV per il quadro completo.",
      viewWork: "Vedi progetti",
      viewCV: "Vedi CV",
      marquee: "★ Benvenuto nella mia homepage ★   Ottimizzato per 800×600   ★   AI Embedded e On-Device · Deep Learning Efficiente · Computer Vision · IoT   ★   Grazie della visita!   ★",
      highlightsTitle: "In evidenza",
      highlights: [
        "Ho addestrato una rete neurale direttamente su un STM32 Cortex-M4, con la backpropagation scritta da zero in C: inferenza in 22 microsecondi e circa 2 KB di RAM.",
        "Tesi magistrale: gli adapter LoRA hanno eguagliato il fine-tuning completo di un modello vocale da 326M di parametri, addestrandone circa dieci volte meno.",
        "Sto prototipando l'anonimizzazione dei volti tramite GAN su hardware edge, per de-identificare i video prima che lascino la telecamera.",
      ],
      ready: "Pronto",
    },
    about: {
      title: "Informazioni - Blocco note",
      menu: ["File", "Modifica", "Cerca", "?"],
      statusFile: "leggimi.txt",
      statusPos: "Riga 1, Col 1",
      p1a: "Sono un ", p1b: "machine learning engineer", p1c: " che lavora su AI embedded e on-device: modelli che devono stare in budget stretti di memoria, latenza ed energia, restando comunque utili.",
      p2a: "La mia ricerca si è concentrata sul far girare a basso costo grandi modelli pre-addestrati, tramite ", p2b: "fine-tuning parameter-efficient e self-supervised learning", p2c: ", su problemi che vanno dal riconoscimento visivo del parlato al rilevamento di crisi epilettiche da EEG.",
      p3a: "Ho recentemente conseguito la laurea magistrale in ", p3b: "Internet of Things", p3c: " (108/110) presso l'", p3d: "Università degli Studi di Salerno", p3e: ", con una tesi sul riconoscimento visivo del parlato efficiente.",
    },
    skills: {
      title: "Risorse del computer - Competenze",
      menu: ["File", "Modifica", "Visualizza", "?"],
      statusObjects: (n) => `${n} oggetti`,
      statusPlace: "Risorse del computer",
    },
    work: {
      title: "Progetti",
      menu: ["File", "Modifica", "Visualizza", "Vai", "?"],
      statusCount: (n) => `${n} progetti`,
      statusHint: "Fai doppio clic per aprire",
      projects: [
        { title: "Riconoscimento visivo del parlato (PEFT)", desc: "Tesi magistrale (108/110): lettura labiale solo visiva con adapter LoRA su un backbone AV-HuBERT congelato, in tre lingue del corpus MuAViC.", labels: ["Tesi", "Slide"] },
        { title: "Intrusion Detection IoT", desc: "Sicurezza IoT in tempo reale con reti neurali embedded su STM32 Nucleo-F401RE.", labels: ["Codice", "Slide"] },
        { title: "Controllo semaforico di emergenza", desc: "Deep reinforcement learning per l'ottimizzazione dei semafori in reti multi-incrocio.", labels: ["Codice", "Report", "Slide"] },
        { title: "Monitoraggio intelligente per reparti ospedalieri", desc: "Progetto di interazione uomo-macchina: monitoraggio IoT di reparto, prototipato e testato con 12 partecipanti clinici.", labels: ["Slide", "Video"] },
        { title: "Manutenzione predittiva industriale", desc: "Revisione sistematica della letteratura sul ML per la manutenzione predittiva su dati di sensori industriali.", labels: ["Report", "Slide"] },
        { title: "Robot per pulizie, sviluppato test-first", desc: "Sei user story per un robot per pulizie embedded, implementate interamente con sviluppo guidato dai test.", labels: ["Codice", "Slide"] },
        { title: "Rilevamento di arte generata dall'IA", desc: "Modello CNN di deep learning che distingue le opere generate dall'IA da quelle reali.", labels: ["Demo", "Report", "Slide"] },
        { title: "Rilevamento incendi e controllo ventola", desc: "Sistema IoT di rilevamento incendi con monitoraggio MQTT e risposta automatica alla temperatura.", labels: ["Codice", "Demo"] },
        { title: "Rilevamento crisi epilettiche (SSL)", desc: "Pre-addestramento self-supervised per il rilevamento di crisi epilettiche da EEG. Tesi magistrale e pubblicazione.", labels: ["Tesi", "Pubblicazione"] },
        { title: "Applicazione CRUD Java", desc: "Progetto finale triennale: applicazione desktop con operazioni complete di creazione/lettura/modifica/eliminazione.", labels: ["Report"] },
        { title: "Sito Archi-Design Studio", desc: "Sito vetrina responsive per uno studio di architettura, realizzato in React.", labels: ["Demo", "Codice"] },
      ],
    },
    documents: {
      title: "Documenti - Report e ricerca",
      menu: ["File", "Modifica", "Visualizza", "?"],
      colName: "Nome", colType: "Tipo", colOpen: "Apri",
      view: "Apri →",
      statusCount: (n) => `${n} documenti`,
      items: [
        { name: "VSR efficiente tramite PEFT di backbone congelati", kind: "Tesi magistrale (IoT)" },
        { name: "Self-Supervised Learning per il rilevamento di crisi epilettiche", kind: "Tesi magistrale" },
        { name: "Manutenzione predittiva industriale data-centric", kind: "Revisione della letteratura" },
        { name: "Rilevamento di arte generata dall'IA", kind: "Report di progetto" },
        { name: "Controllo semaforico di emergenza", kind: "Report di progetto" },
        { name: "Sicurezza IoT - Sistema di intrusion detection", kind: "Presentazione" },
        { name: "Software Dependability - Apache Commons CLI", kind: "Report di progetto" },
        { name: "Robot per pulizie, Test-Driven Development", kind: "Presentazione" },
        { name: "Monitoraggio intelligente per reparti ospedalieri", kind: "Presentazione" },
        { name: "Motore CC a controllo di temperatura", kind: "Report di progetto" },
        { name: "Applicazione CRUD Java (PFE Licence SI)", kind: "Progetto triennale" },
      ],
    },
    contact: {
      title: "Nuovo messaggio - Contattami",
      intro: "Ti piace quello che vedi? Scrivimi. Clicca l'indirizzo per copiarlo.",
      to: "A:",
      copyTitle: "Copia negli appunti",
      copied: "✓ Copiato negli appunti!",
      findMe: "Oppure mi trovi su:",
      resume: "CV",
      statusOnline: "In linea",
      statusRecipient: "1 destinatario",
    },
    footer: {
      madeA: "Realizzato con", madeC: "da Zakarya",
      visitor: "Sei il visitatore",
    },
    taskbar: {
      start: "Avvio",
      shutdown: "Arresta il sistema…",
      safeOff1: "Ora è possibile spegnere",
      safeOff2: "il computer.",
      powerOn: "⏻ Riaccendi",
      appearance: "Aspetto",
      resume: "CV",
      email: "E-mail",
      langTitle: "Lingua: Italiano, click for English",
    },
  },
};

export default strings;
